import React from "react";
import dynamic from "next/dynamic";

const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true },
);
const RequestProposal = dynamic(() => import("./request-proposal"), {
  ssr: true,
});
const CareerPage = dynamic(() => import("./career"), {
  ssr: true,
});
const AboutUS = dynamic(() => import("./about-us"), {
  ssr: true,
});
const LocateUS = dynamic(() => import("./locate-us"), {
  ssr: true,
});

interface ItemPageProps {
  referer: string;
  slug: string;
  data: any;
  isMobile?: boolean;
  listData?: any[];
}

const ItemPage: React.FC<ItemPageProps> = (props) => {
  const referer = props.referer;
  const isMobile = props.isMobile;
  const listData = props.listData;
  const data = props?.data?.data?.[0]?.attributes;
  const seo = data?.seo || " Trootech";
  const breadcrumbs = data?.breadcrumbs;
  const blocks = data?.blocks;

  const SwitchCase = (template: string) => {
    switch (template) {
      /* case "About Us":
              return <About blocks={blocks} />;
            case "Contact Us":
              return <ContactUs data={data} referer={referer} />;
            case "Career":
              return <Career blocks={blocks} />;
            case "Home":
              return <HomeNew blocks={blocks} />; */
      case "Contact Us":
        return <LocateUS blocks={data} />;
      case "About Us":
        return <AboutUS blocks={blocks} breadcrumbs={breadcrumbs} />;
      case "Career":
        return (
          <CareerPage
            blocks={blocks}
            referer={referer}
            isMobile={isMobile}
            listData={listData}
          />
        );
      case "Contact Us New":
        return (
          <RequestProposal
            blocks={blocks}
            referer={referer}
            isMobile={isMobile}
          />
        );
      /* case "Hire Now":
              return <HireNow blocks={blocks} />; */
      default:
        return "";
    }
  }
  return (
    <>
      {seo && <HocHead seo={seo} />}
      {/* {loading && <FullPageLoader />} */}

      {SwitchCase(data?.template as string)}
    </>
  );
};

export default ItemPage;
